import Schedule from '@mui/icons-material/Schedule';
import { Alert, AlertTitle } from '@mui/material';
import { useGuestJourneyStatus } from 'pages/analytics/guest-journey/guest-journey-status.hooks';
import { useTranslation } from 'react-i18next';

/**
 * Settings-page notice shown while a saved threshold change is queued for the
 * next nightly run. Driven by the same report-level
 * `settingsProcessing` flag as the report banner, but with
 * settings-specific copy (it speaks to "reports", not "the data below") per the
 * design. Self-contained: renders nothing unless a change is pending, so it can
 * drop straight into the editor without threading the status through.
 */
const GuestJourneySettingsProcessingNotice = () => {
  const { t } = useTranslation();
  const status = useGuestJourneyStatus();

  if (!status?.settingsProcessing) return null;

  return (
    <Alert
      severity="info"
      icon={<Schedule />}
      data-testid="GuestJourney.Settings.Processing"
    >
      <AlertTitle>
        {t('page.guestJourney.settings.processing.title')}
      </AlertTitle>
      {t('page.guestJourney.settings.processing.text')}
    </Alert>
  );
};

export default GuestJourneySettingsProcessingNotice;
